"use client";

import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { SUPPORT_EMAIL } from "@/lib/site-config";
import { useTranslations } from "@/components/i18n/use-translations";

const SECTION_ORDER = [
    "overview",
    "localData",
    "noTransfer",
    "capture",
    "retention",
    "permissions",
    "thirdParties",
    "choices",
    "contact",
] as const;

export default function ElktrailPrivacyPage() {
    const { messages } = useTranslations();
    const contactBody = messages.elktrailPrivacy.sections.contact.body.replace("{email}", SUPPORT_EMAIL);

    return (
        <div className="mx-auto max-w-2xl px-4 py-8">
            <header className="space-y-3 text-center mb-8">
                <p className="text-xs uppercase tracking-[0.2em] text-cyan-400/90">ELKTrail by clizSec</p>
                <h1 className="text-3xl font-semibold tracking-tight text-white">{messages.elktrailPrivacy.title}</h1>
                <p className="text-sm text-gray-400">{messages.elktrailPrivacy.description}</p>
                <p className="text-xs text-gray-500">{messages.elktrailPrivacy.updated}</p>
            </header>

            <Accordion type="single" collapsible className="w-full space-y-4">
                {SECTION_ORDER.map((key) => {
                    const section = messages.elktrailPrivacy.sections[key];
                    const body = key === "contact" ? contactBody : section.body;

                    return (
                        <AccordionItem
                            key={key}
                            value={key}
                            className="border border-cyan-700/40 rounded-lg px-4 bg-slate-900/30"
                        >
                            <AccordionTrigger className="text-lg font-semibold text-white hover:text-gray-300">
                                {section.title}
                            </AccordionTrigger>
                            <AccordionContent className="wrap-break-word text-sm text-gray-400 whitespace-pre-line">
                                {key === "contact" ? (
                                    <>
                                        {body.split(SUPPORT_EMAIL)[0]}
                                        <a
                                            href={`mailto:${SUPPORT_EMAIL}`}
                                            className="mx-1 inline-flex items-center font-semibold text-cyan-300 transition-colors hover:text-cyan-200"
                                        >
                                            {SUPPORT_EMAIL}
                                        </a>
                                        {body.split(SUPPORT_EMAIL)[1] ?? ""}
                                    </>
                                ) : (
                                    body
                                )}
                            </AccordionContent>
                        </AccordionItem>
                    );
                })}
            </Accordion>
        </div>
    );
}
